import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { RiAddCircleLine } from 'react-icons/ri';

import TableauSensorType from './TableauSensorType/TableauSensorType';
import ProfilSensorType from './ProfilSensorType/ProfilSensorType';
import AjouterSensorType from './Ajouter/AjouterSensorType';
import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';

import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as actions from '../../../services/actions';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import styles from './SensorType.module.scss';

const SensorType = () => {
  // Separate state hooks
  const [selectedInfo, setSelectedInfo] = useState({});
  const [showCreate, setShowCreate] = useState(false);

  const dispatch = useDispatch();

  const handleLineSelection = (line) => {
    setSelectedInfo(line);
  };

  const handleShowCreate = () => {
    setShowCreate(true);
  };

  const handleHideCreate = () => {
    setShowCreate(false);
  };

  const handleAdd = (sensorTypeName, sensor_type_display) => {
    dispatch(actions.reqAjouterSensorType(sensorTypeName, sensor_type_display));
  };

  const handleModify = (
    idSensorType,
    sensor_type_name,
    sensor_type_display
  ) => {
    dispatch(
      actions.reqModifierSensorType(
        idSensorType,
        sensor_type_name,
        sensor_type_display
      )
    );
  };

  const handleDelete = (sensorTypeName) => {
    dispatch(actions.reqSupprimerSensorType(sensorTypeName));
  };

  return (
    <div className={s.row}>
      <div className={s.col_sm_6}>
        <h4>{checkMot('liste_des_sensors_types')}</h4>
        <AccesRestreins
          listNumPrivilege={[
            privilege.creer_des_sensor_types,
            privilege.modifier_des_sensor_types,
            privilege.supprimer_des_sensor_types,
            privilege.recuperer_list_sensor_type,
          ]}
        >
          <TableauSensorType selectioneLigne={handleLineSelection} />
        </AccesRestreins>
        <AccesRestreins numPrivilege={privilege.creer_des_sensor_types}>
          <button onClick={handleShowCreate} className={styles.btadd}>
            <RiAddCircleLine size={24} />
            {checkMot('ajouter_sensor_types')}
          </button>
        </AccesRestreins>
      </div>
      <div className={s.col_sm_6}>
        {showCreate ? (
          <span style={{ display: 'block' }}>
            <AjouterSensorType
              reqAjouter={handleAdd}
              annuler={handleHideCreate}
            />
          </span>
        ) : (
          <ProfilSensorType
            InfoSelect={selectedInfo}
            reqModifier={handleModify}
            reqSupprimer={handleDelete}
          />
        )}
      </div>
    </div>
  );
};

export default SensorType;
